import styled from 'styled-components';

export const HintButton = styled.div`
  height: 14px;
  position: absolute;
  bottom: 0;
  left: 50%;
  background-color: #fff;
  color: #222;
  padding: 0 20px;
  border-radius: 12px;
  cursor: pointer;
  z-index: 9999999;
  opacity: 0.8;
  transform: translateX(-50%);

  &:hover {
    opacity: 1;
  }
`;
